import React from "react";
// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import Table from "../../widgets/tables/Table";
import WaitDialog from "../../widgets/WaitDialog";

import SendMailWidget from "../../widgets/SendMailWidget";
import SendNotificationWidget from "../../widgets/SendNotificationWidget";
import GetStudenti from "../../services/getStudenti";
import DeleteStudente from "../../services/deleteStudente";
import addNotification from "../../services/addNotification";
import sendMail from "../../services/sendMail";
import saveFile from "../../services/saveFile";
import getSetting from "../../services/getSetting";
import Utils from "../../utils/utils";
import getLezioni from "../../services/getLezioni";
import getAssenzeNonGiustificate from "../../services/getAssenzeNonGiustificate";
import getCorsi from "../../services/getCorsi";
import getCategorieCorsi from "../../services/getCategorieCorsi";
import blackListStudente from "../../services/addBlackList";

export default class BlackList extends React.Component {
	constructor(props) {
		super(props);

		this.pageDiv = {
			border: "1px solid #cccccc",
			padding: 10,
		};

		this.pageTitle = props.pageTitle;
		this.pageName = props.pageName;
		if (this.pageName == undefined) {
			this.pageName = this.section;
		}

		this.options = [{ value: "All", label: "All" }];

		this.selectRef = React.createRef();

		this.state = {
			testo: "",
			menuBackground: "#ffffff",
			menuItemColor: "#000000",
			fontSize: 50,
			fontBold: false,
			logoPicture: "",
			logoMargin: 0,
			titleColor: "#000000",
			titleSize: 18,
			isLoading: false,
			addElementVisible: false,
			waitDialogVisible: false,
			mailCompaniesList: [],
			corsi: [],
			selectedCategoria: null,
			selectedCorsi: null,
			optionsCategoria: [],
			studentiFiltrati: [],
			studenti: [],
			corsiAssociati: [],
		};

		this.grid = 2;

		this.pdfElements = [];

		this.studenti = [];
		this.pageTitle = "Blacklist";
		this.brokerId = undefined;

		const cookies = new Cookies();
		var strJson = JSON.stringify({ list: [] });
		cookies.set("checksList", strJson, { path: "/" });

		this.sendMailRef = React.createRef();
		this.sendNotificationRef = React.createRef();

		this.handleCategoriaChange = this.handleCategoriaChange.bind(this);
		this.handleCorsiChange = this.handleCorsiChange.bind(this);

		this.state = {
			studenti: [],
		};
	}

	handleCategoriaChange(option) {
		this.setState({ selectedCategoria: option, selectedCorsi: null }, () => {
			this.reload();
		});
	}

	handleCorsiChange(option) {
		this.setState({ selectedCorsi: option }, () => {
			this.reload();
		});
	}

	async reload() {
		const cookies = new Cookies();
		const username = cookies.get("username", { path: "/" });
		const token = cookies.get("token", { path: "/" });

		this.studenti = await GetStudenti(username, token);
		this.lezioni = await getLezioni(username, token);
		this.assenze = await getAssenzeNonGiustificate(username, token);
		this.corsi = await getCorsi(username, token);
		this.categorieCorsi = await getCategorieCorsi(username, token);

		const { selectedCategoria, selectedCorsi } = this.state;

		let studentiFiltrati = this.studenti.filter(studente => studente.blacklist === 1);

		if (selectedCategoria?.value === "seleziona tutti") {
		} else if (selectedCategoria) {
			studentiFiltrati = studentiFiltrati.filter(studente => {
				const corsiStudenteIds = studente.corsi
					? studente.corsi
							.split(";")
							.map(id => Number(id.trim()))
							.filter(id => !isNaN(id))
					: [];

				const corsiAssociatiStudente = corsiStudenteIds
					.map(idCorso => this.corsi.find(corso => corso.id === idCorso))
					.filter(Boolean);

				return corsiAssociatiStudente.some(corso => corso.id_categoria === selectedCategoria.value);
			});
		}

		if (selectedCorsi?.value === "seleziona tutti") {
		} else if (selectedCorsi) {
			const corsoId = selectedCorsi.value;
			studentiFiltrati = studentiFiltrati.filter(studente => {
				return studente.corsi
					? studente.corsi
							.split(";")
							.map(id => Number(id.trim()))
							.includes(corsoId)
					: false;
			});
		}

		let corsiAssociati = [];
		if (selectedCategoria && selectedCategoria.value !== "seleziona tutti") {
			corsiAssociati = this.corsi.filter(corso => corso.id_categoria === selectedCategoria.value);
		}

		const corsiAssociatiFormat = corsiAssociati.map(corso => ({
			value: corso.id,
			label: corso.name,
		}));

		this.studenti.forEach(s => {
			let ass = this.assenze.filter(a => a.id_studente === s.id);
			s.assenze_non_giustificate = ass.length;
		});

		const optionsCategoria = this.categorieCorsi.map(categoria => ({
			value: categoria.id,
			label: categoria.name,
		}));

		this.setState({
			studenti: this.studenti,
			corsi: this.corsi,
			optionsCategoria: [{ label: "SELEZIONA TUTTI", value: "seleziona tutti" }, ...optionsCategoria],
			studentiFiltrati,
			corsiAssociati: [{ label: "SELEZIONA TUTTI", value: "seleziona tutti" }, ...corsiAssociatiFormat],
		});
	}

	async componentDidMount() {
		await this.reload();
	}

	render() {
		var headCells = [
			{ id: "nome", numeric: false, disablePadding: true, label: "Nome" },
			{ id: "cognome", numeric: true, disablePadding: false, label: "Cognome" },
			{ id: "mail", numeric: true, disablePadding: false, label: "Mail" },
			{ id: "_", numeric: true, disablePadding: false, label: "" },
		];

		const studentiFiltrati = this.state.studentiFiltrati || [];

		const corsiAssociati = this.state.corsiAssociati || [];

		this.searchCols = ["nome", "cognome", "mail"];

		const studentBlacklist = this.state.studenti
			.filter(studente => studente.blacklist === 1)
			.map(studente => studente.id);

		const cookies = new Cookies();

		return (
			<>
				<LoadingOverlay
					active={this.state.isLoading}
					styles={{
						content: base => ({
							position: "relative",
							width: "100%",
							top: "200px",
						}),
					}}
					spinner
					text={"Loading your content..."}
				>
					<PageTitle
						title={this.pageTitle}
						button="NUOVO"
						onClick={() => {
							window.location.href = "/#/app/addStudente";
						}}
					/>

					<Table
						filtroCorsi
						headCells={headCells}
						searchCols={this.searchCols}
						categorie={this.state.optionsCategoria}
						corsiAssociati={corsiAssociati}
						selectedCategoria={this.state.selectedCategoria}
						selectedCorsi={this.state.selectedCorsi}
						assenze={false}
						blackList={studentBlacklist}
						calendar={false}
						onChangeCategoria={this.handleCategoriaChange}
						onChangeCorsi={this.handleCorsiChange}
						pdf={false}
						excel={false}
						mail={false}
						phone={false}
						rows={studentiFiltrati}
						onEventClick={row => {
							cookies.set("currentStudente", row, { path: "/" });
							window.location.href = "/#/app/editStudente";
						}}
						onBlacklistPressed={async id => {
							const studente = this.state.studenti.find(studente => studente.id === id);

							const isInBlacklist = studente && studente.blacklist === 1;
							const message = isInBlacklist
								? "Sei sicuro di voler togliere lo studente dalla blacklist?"
								: "Sei sicuro di voler mettere in blacklist lo studente?";

							if (window.confirm(message) === false) return;

							const cookies = new Cookies();
							const username = cookies.get("username", { path: "/" });
							const token = cookies.get("token", { path: "/" });

							await blackListStudente(username, token, id);

							const alertMessage = isInBlacklist
								? "Studente rimosso dalla blacklist"
								: "Studente aggiunto alla blacklist";
							window.alert(alertMessage);

							this.reload();
						}}
						onDelete={async id => {
							if (window.confirm("Sei sicuro di voler eliminare lo studente?") == false) return;

							const cookies = new Cookies();
							const username = cookies.get("username", { path: "/" });
							const token = cookies.get("token", { path: "/" });
							await DeleteStudente(username, token, id);
							this.reload();
						}}
					/>

					<WaitDialog show={this.state.waitDialogVisible} key={Math.random()} index={this.state.index} />
				</LoadingOverlay>
			</>
		);
	}
}
